<accordion [isAnimated]="true" [closeOthers]="true" class="pace-spector-address-accordion">
    @if (items().length === 0) {
        <alert type="info" class="m-2">No addresses to display.</alert>
    } @else {
        @for (addr of items(); track $index) {
            <accordion-group [isOpen]="$index === 0" [panelClass]="addr.panelClass">
                <button
                    class="btn btn-link btn-block justify-content-between d-flex w-100 shadow-none"
                    accordion-heading
                    type="button"
                >
                    <div class="pull-left float-left">{{ addr.heading }}</div>
                    <div class="pull-right float-right d-flex gap-2">
                        @if (addr.deleted) {
                            <fa-icon [icon]="faTrashCan"></fa-icon>
                        }
                        @if (!addr.visible) {
                            <fa-icon [icon]="faEyeSlash"></fa-icon>
                        }
                        @if (addr.manual) {
                            <fa-icon [icon]="faUserPen"></fa-icon>
                        } @else {
                            <fa-icon [icon]="faServer"></fa-icon>
                        }
                    </div>
                </button>

                <div class="addr-summary">
                    @for (line of addr.summary; track $index) {
                        <div class="addr-summary-line">{{ line }}</div>
                    }
                    @if (addr.manual) {
                        <div class="addr-summary-line"><fa-icon [icon]="faUserPen"></fa-icon> manually created</div>
                    } @else {
                        <div class="addr-summary-line">
                            <fa-icon [icon]="faServer"></fa-icon> obtained from upstream
                        </div>
                    }
                    <div class="addr-actions">
                        @if (addr.deleted) {
                            <div>
                                <fa-icon [icon]="faTrashCan"></fa-icon> Deleted
                                <button type="button" class="btn btn-sm btn-danger" (click)="undelete(addr.id)">
                                    Undelete
                                </button>
                            </div>
                        } @else {
                            <div>
                                <button type="button" class="btn btn-sm btn-danger" (click)="delete(addr.id)">
                                    Mark deleted
                                </button>
                            </div>
                        }
                        @if (!addr.visible) {
                            <div>
                                <fa-icon [icon]="faEyeSlash"></fa-icon> Hidden
                                <button type="button" class="btn btn-sm btn-danger" (click)="unhide(addr.id)">
                                    Unhide
                                </button>
                            </div>
                        } @else {
                            <div>
                                <button type="button" class="btn btn-sm btn-danger" (click)="hide(addr.id)">
                                    Hide Address
                                </button>
                            </div>
                        }
                    </div>
                </div>

                <hr class="my-3" />

                <div class="table-responsive">
                    <table class="table table-sm table-striped table-hover align-middle">
                        <thead class="table-light">
                            <tr>
                                <th style="width: 220px">Field</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of addr.details | keyvalue; track row.key) {
                                <tr>
                                    <td class="text-muted">{{ row.key }}</td>
                                    <td>
                                        <pre class="mb-0 pretty">{{ row.value }}</pre>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </accordion-group>
        }
        <accordion-group heading="Raw JSON">
            <div class="d-flex flex-row justify-content-end gap-2">
                <button type="button" class="btn btn-sm btn-info" (click)="copyJson()">Copy JSON</button>
                <button type="button" class="btn btn-sm btn-info" (click)="triggerDownloadJson()">Download JSON</button>
            </div>
            <pre class="small mb-0">{{ addresses() | json }}</pre>
        </accordion-group>
    }
</accordion>

<div class="d-flex flex-row justify-content-end gap-2 mt-3">
    <!--    <button-->
    <!--        type="button"-->
    <!--        class="btn btn-danger"-->
    <!--        (click)="triggerDeleteLocal()"-->
    <!--        translate="PACESPECTOR_DELETE_LOCAL"-->
    <!--    ></button>-->
</div>
